import React, { useMemo, useState } from 'react';

import { Check, Copy } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import { Currency } from '@/constants';
import useBuildInfoStore from '@/hooks/useBuildInfo';

const BuildDetailsCopyIdsAll: React.FC = () => {
  const [isCopied, setIsCopied] = useState(false);

  const { buildInfo } = useBuildInfoStore();

  const collectAllContractAddresses = useMemo(() => {
    return Object.entries(buildInfo || {}).reduce<string[]>((acc, [token, value]) => {
      if (Object.values(Currency).includes(token as Currency)) {
        acc.push(token);
        if (typeof value === 'object') {
          if ('L1_CONTRACT_ADDRESS_BASE' in value) {
            acc.push('L1_CONTRACT_ADDRESS_BASE');
            acc.push(value['L1_CONTRACT_ADDRESS_BASE']?.id ?? '');
          }
          if ('L1_CONTRACT_ADDRESS_MAKER' in value) {
            acc.push('L1_CONTRACT_ADDRESS_MAKER');
            acc.push(value['L1_CONTRACT_ADDRESS_MAKER']?.id || '');
          }
          if ('L2_CONTRACT_ADDRESS_BASE' in value) {
            acc.push('L2_CONTRACT_ADDRESS_BASE');
            acc.push(value['L2_CONTRACT_ADDRESS_BASE']?.id || '');
          }
          if ('L2_CONTRACT_ADDRESS_MAKER' in value) {
            acc.push('L2_CONTRACT_ADDRESS_MAKER');
            acc.push(value['L2_CONTRACT_ADDRESS_MAKER']?.id || '');
          }
        }
      }

      return acc;
    }, []);
  }, [buildInfo?.build]);

  const handleCopy = () => {
    void navigator.clipboard.writeText(collectAllContractAddresses.join('\n'));
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
  };

  return (
    <Button variant="secondary" className="gap-1" onClick={handleCopy}>
      {isCopied ? <Check className="size-4 text-green-500" /> : <Copy className="size-4" />}
      Export Contracts
    </Button>
  );
};

export default BuildDetailsCopyIdsAll;
